var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"短信设置","name":"sms"}},[_c('SmsSetting')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }